import React from "react";
import { Link } from "react-scroll";
import { ReactTyped } from "react-typed";

const Hero = () => (
  <section
    id="home"
    className="relative min-h-screen flex items-end justify-center px-6 pb-32"
  >
    <div className="max-w-4xl mx-auto text-center">
      <p className="text-sm md:text-base font-medium tracking-[0.3em] uppercase text-white/90 text-shadow mb-4">
        Hi, I'm
      </p>
      <h1 className="font-display text-5xl md:text-7xl font-bold text-white text-shadow-strong mb-4">
        Alexander Lasson
      </h1>
      <p className="text-xl md:text-2xl text-white/95 text-shadow font-medium h-8 mb-8">
        <ReactTyped
          strings={[
            "Fullstack Engineer",
            "React · Three.js · Django",
            "From database to pixel",
            "CI/CD &amp; DevOps minded",
          ]}
          typeSpeed={45}
          backSpeed={28}
          backDelay={1700}
          loop
        />
      </p>

      <div className="flex flex-wrap items-center justify-center gap-4">
        <Link
          to="projects"
          smooth={true}
          duration={600}
          offset={-40}
          className="cursor-pointer px-6 py-3 rounded-full bg-ember text-white font-semibold shadow-lg shadow-ember/30
                     hover:shadow-ember/50 hover:-translate-y-0.5 transition-all duration-300"
        >
          View Projects
        </Link>
        <Link
          to="contact"
          smooth={true}
          duration={600}
          offset={-40}
          className="cursor-pointer px-6 py-3 rounded-full border border-white/40 bg-dusk-900/30 text-white font-semibold
                     hover:bg-white/10 hover:-translate-y-0.5 transition-all duration-300"
        >
          Get in Touch
        </Link>
      </div>
    </div>

    <Link
      to="about"
      smooth={true}
      duration={600}
      offset={-40}
      className="absolute bottom-8 left-1/2 -translate-x-1/2 cursor-pointer text-white/80 hover:text-white"
      aria-label="Scroll to about section"
    >
      <i className="fas fa-chevron-down text-2xl animate-drift-down"></i>
    </Link>
  </section>
);

export default Hero;
